import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { resolveErrorMessage } from 'helpers'
import dialog from 'services/dialog'
import useMounted from 'use/mounted'

// Modal
import Ecwt from 'models/Ecwt'

// Api
import { tagAcknowledged } from 'api/ecwt'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Modal from 'ui/Modal'
import Button from 'ui/Button'
import IconQuestion from 'ui/Icons/IconQuestion'
import Text from 'ui/Text'
import Checkbox from 'antd/lib/checkbox/Checkbox'

export const PopupAcknowledge = ({ ecwt, next, onRaiseTicket }) => {
  // State
  const [visible, setVisible] = useState(true)
  const [loading, setLoading] = useState(false)
  const [checked, setChecked] = useState(false)
  const isMounted = useMounted()

  const onCancelClick = () => {
    setVisible(false)
  }

  const onConfirmClick = async () => {
    try {
      setLoading(true)
      await tagAcknowledged(ecwt.id)

      next()
    } catch (error) {
      setChecked(false)
      dialog.alert({
        title: await resolveErrorMessage(error),
      })
    } finally {
      if (isMounted.current) {
        setLoading(false)
        setVisible(false)
      }
    }
  }

  return (
    <Modal show={visible} size="mdl" className="x-confirm-wrap">
      <div className="wrap-icon">
        <IconQuestion />
      </div>
      <Text size={24} bold paddingBottom={5} color="#000000">
        Acknowledge e-CWT
      </Text>
      <Text size={18} color="#000000" paddingBottom={20}>
        <div>
          <Text color="#000000" size={16}>
            Please confirm that you have reviewed the e-Creditable Withholding
            Tax above and that it is true and correct.
          </Text>
          <div className="d-flex mt-3">
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            >
              <div style={{ textAlign: 'start' }}>
                <Text color="#000000" size={16} bold={checked}>
                  I confirm that the e-Creditable Withholding Tax above is true
                  and correct
                </Text>
              </div>
            </Checkbox>
          </div>
          <div
            style={{
              color: '#000000',
              paddingTop: 15,
              fontSize: 16,
            }}
          >
            Should you have any concerns or questions regarding the document
            above, you can{' '}
            <Button
              variant="link"
              underline
              onClick={onRaiseTicket}
              style={{
                minHeight: 'auto',
                marginTop: '-3px',
              }}
            >
              raise a ticket
            </Button>
          </div>
        </div>
      </Text>

      <Row multiline>
        <Col xs={12} sm={6}>
          <Button
            block
            variant="outline-primary"
            disabled={loading}
            onClick={onCancelClick}
          >
            Cancel
          </Button>
        </Col>

        <Col xs={12} sm={6}>
          <Button
            block
            loading={loading}
            onClick={onConfirmClick}
            disabled={!checked}
          >
            Proceed
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

PopupAcknowledge.propTypes = {
  ecwt: PropTypes.instanceOf(Ecwt),
  next: PropTypes.func,
  onRaiseTicket: PropTypes.func,
}

PopupAcknowledge.defaultProps = {
  ecwt: new Ecwt(),
  next: () => {},
  onRaiseTicket: () => {},
}

export default PopupAcknowledge
